<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <!--<button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
  <mat-icon>close</mat-icon>
</button>-->
<hr>
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">

      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
            <div class="w-100"
              style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
              <p><b>{{formAlert}}</b></p>
            </div>
          </div>
        }
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="name" id="name" type="text" pInputText>
          <label for="name">Name</label>
          @for (validation of validationMessages.name; track validation) {
            <span>
              @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6"></div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name" id="status"
          optionValue="value"></p-dropdown>
          <label for="status">status</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6"></div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="activityTypes" formControlName="activityType" optionLabel="name"
          optionValue="value" placeholder="Activity Types"></p-dropdown>
          <label for="Activity Types">Activity Types</label>
          @for (validation of validationMessages.activityType; track validation) {
            <span>
              @if (form1.get('activityType').hasError(validation.type) && (form1.get('activityType').dirty || form1.get('activityType').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6"></div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="invoiceType" id="invoiceType" type="text" pInputText>
          <label for="invoiceType">Invoice Type</label>
          @for (validation of validationMessages.invoiceType; track validation) {
            <span>
              @if (form1.get('invoiceType').hasError(validation.type) && (form1.get('invoiceType').dirty || form1.get('invoiceType').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6"></div>

      <h2>Address</h2><hr>
      <div class="row m-0">
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="addressTypes" formControlName="adrType" optionLabel="name" optionValue="value"
            placeholder="Select Address Type"></p-dropdown>
            <label for="Select Address Type">Select Address Type</label>
            @for (validation of validationMessages.adrType; track validation) {
              <span>
                @if (form1.get('adrType').hasError(validation.type) && (form1.get('adrType').dirty || form1.get('adrType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrStreetNumber" id="adrStreetNumber" type="text" pInputText>
            <label for="adrStreetNumber">Address Street Number</label>
            @for (validation of validationMessages.adrStreetNumber; track validation) {
              <span>
                @if (form1.get('adrStreetNumber').hasError(validation.type) && (form1.get('adrStreetNumber').dirty || form1.get('adrStreetNumber').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrStreetName" id="adrStreetName" type="text" pInputText>
            <label for="adrStreetName">Address Street Name</label>
            @for (validation of validationMessages.adrStreetName; track validation) {
              <span>
                @if (form1.get('adrStreetName').hasError(validation.type) && (form1.get('adrStreetName').dirty || form1.get('adrStreetName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrUnit" id="adrUnit" type="text" pInputText>
            <label for="adrUnit">Address Unit</label>
            @for (validation of validationMessages.adrUnit; track validation) {
              <span>
                @if (form1.get('adrUnit').hasError(validation.type) && (form1.get('adrUnit').dirty || form1.get('adrUnit').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adr2" id="adr2" type="text" pInputText>
            <label for="adr2">Address2</label>
            @for (validation of validationMessages.adr2; track validation) {
              <span>
                @if (form1.get('adr2').hasError(validation.type) && (form1.get('adr2').dirty || form1.get('adr2').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrCity" id="adrCity" type="text" pInputText>
            <label for="adrCity">Address City</label>
            @for (validation of validationMessages.adrCity; track validation) {
              <span>
                @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrCounty" id="adrCounty" type="text" pInputText>
            <label for="adrCounty">Address County</label>
            @for (validation of validationMessages.adrCounty; track validation) {
              <span>
                @if (form1.get('adrCounty').hasError(validation.type) && (form1.get('adrCounty').dirty || form1.get('adrCounty').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrRegion" id="adrRegion" type="text" pInputText>
            <label for="adrRegion">Address Region</label>
            @for (validation of validationMessages.adrRegion; track validation) {
              <span>
                @if (form1.get('adrRegion').hasError(validation.type) && (form1.get('adrRegion').dirty || form1.get('adrRegion').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="states" formControlName="adrState" appendTo="body" optionLabel="name" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Select State"></p-dropdown>
            <label for="Select State">Select State</label>
            @for (validation of validationMessages.adrState; track validation) {
              <span>
                @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="countries" formControlName="adrCountry" appendTo="body" optionLabel="name" optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
            placeholder="Select Country"></p-dropdown>
            <label for="Select Country">Select Country</label>
            @for (validation of validationMessages.adrCountry; track validation) {
              <span>
                @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrPostalCode" id="adrPostalCode" type="text" pInputText>
            <label for="adrPostalCode">Address Postal Code</label>
            @for (validation of validationMessages.adrPostalCode; track validation) {
              <span>
                @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty || form1.get('adrPostalCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrIsland" id="adrIsland" type="text" pInputText>
            <label for="adrIsland">Address Island</label>
            @for (validation of validationMessages.adrIsland; track validation) {
              <span>
                @if (form1.get('adrIsland').hasError(validation.type) && (form1.get('adrIsland').dirty || form1.get('adrIsland').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrCrossStreet" id="adrCrossStreet" type="text" pInputText>
            <label for="adrCrossStreet">Address Cross Street</label>
            @for (validation of validationMessages.adrCrossStreet; track validation) {
              <span>
                @if (form1.get('adrCrossStreet').hasError(validation.type) && (form1.get('adrCrossStreet').dirty || form1.get('adrCrossStreet').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrLatitude" id="adrLatitude" type="text" pInputText>
            <label for="adrLatitude">Address Latitude</label>
            @for (validation of validationMessages.adrLatitude; track validation) {
              <span>
                @if (form1.get('adrLatitude').hasError(validation.type) && (form1.get('adrLatitude').dirty || form1.get('adrLatitude').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrLongitude" id="adrLongitude" type="text" pInputText>
            <label for="adrLongitude">Address Longitude</label>
            @for (validation of validationMessages.adrLongitude; track validation) {
              <span>
                @if (form1.get('adrLongitude').hasError(validation.type) && (form1.get('adrLongitude').dirty || form1.get('adrLongitude').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="locationCategories" formControlName="locationCategory" optionLabel="name" id="locationCategory"
            optionValue="value"></p-dropdown>
            <label for="locationCategory">Location Category</label>
            @for (validation of validationMessages.locationCategory; track validation) {
              <span>
                @if (form1.get('locationCategory').hasError(validation.type) && (form1.get('locationCategory').dirty || form1.get('locationCategory').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <h2>Overview</h2><hr>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            <p-multiSelect class="lead-select" [options]="availabilityList" formControlName="availableDays" appendTo="body"
            defaultLabel="Available Days" optionLabel="name" display="chip"></p-multiSelect>
            <label for="availableDays">Available Days</label>
            @for (validation of validationMessages.availableDays; track validation) {
              <span>
                @if (form1.get('availableDays').hasError(validation.type) && (form1.get('availableDays').dirty || form1.get('availableDays').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            <p-multiSelect class="lead-select" [options]="pickUpList" formControlName="pickUpAvailable" appendTo="body"
            defaultLabel="Pick-Up Available??" optionLabel="name" display="chip"></p-multiSelect>
            <label for="pickUpAvailable">Pick-Up Available??</label>
            @for (validation of validationMessages.pickUpAvailable; track validation) {
              <span>
                @if (form1.get('pickUpAvailable').hasError(validation.type) && (form1.get('pickUpAvailable').dirty || form1.get('pickUpAvailable').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            <p-multiSelect class="lead-select" [options]="accessibleList" formControlName="accessibleTransport" appendTo="body"
            defaultLabel="Transportation Accessible" optionLabel="name" display="chip"></p-multiSelect>
            <label for="accessibleTransport">Transportation Accessible</label>
            @for (validation of validationMessages.accessibleTransport; track validation) {
              <span>
                @if (form1.get('accessibleTransport').hasError(validation.type) && (form1.get('accessibleTransport').dirty || form1.get('accessibleTransport').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            <p-multiSelect class="lead-select" [options]="eatingList" formControlName="eatingTime" appendTo="body"
            defaultLabel="Meal??" optionLabel="name" display="chip"></p-multiSelect>
            <label for="eatingTime">Meal??</label>
            @for (validation of validationMessages.eatingTime; track validation) {
              <span>
                @if (form1.get('eatingTime').hasError(validation.type) && (form1.get('eatingTime').dirty || form1.get('eatingTime').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            <p-multiSelect class="lead-select" [options]="languageList" formControlName="language" appendTo="body"
            defaultLabel="Language" optionLabel="name" display="chip"></p-multiSelect>
            <label for="language">Language</label>
            @for (validation of validationMessages.language; track validation) {
              <span>
                @if (form1.get('language').hasError(validation.type) && (form1.get('language').dirty || form1.get('language').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="leadDescription" id="leadDescription" [rows]="2" pInputTextarea></textarea>
            <label for="leadDescription">Lead Description</label>
            @for (validation of validationMessages.leadDescription; track validation) {
              <span>
                @if (form1.get('leadDescription').hasError(validation.type) && (form1.get('leadDescription').dirty || form1.get('leadDescription').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="opsNotes"><strong>Ops Notes :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="opsNotes" id="opsNotes" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="opsNotes"
              id="opsNotes"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="overviewDesc"><strong>Overview Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="overviewDesc" id="overviewDesc" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="overviewDesc"
              id="overviewDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            <!--<label for="overviewDesc">Overview Description</label>-->
            @for (validation of validationMessages.overviewDesc; track validation) {
              <span>
                @if (form1.get('overviewDesc').hasError(validation.type) && (form1.get('overviewDesc').dirty || form1.get('overviewDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="detailsDesc"><strong>Details Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="detailsDesc" id="detailsDesc" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="detailsDesc"
              id="detailsDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            <!--<label for="detailsDesc">Details Description</label>-->
            @for (validation of validationMessages.detailsDesc; track validation) {
              <span>
                @if (form1.get('detailsDesc').hasError(validation.type) && (form1.get('detailsDesc').dirty || form1.get('detailsDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="durationDesc"><strong>Duration Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="durationDesc" id="durationDesc" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="durationDesc"
              id="durationDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            <!--<label for="durationDesc">Duration Description</label>-->
            @for (validation of validationMessages.durationDesc; track validation) {
              <span>
                @if (form1.get('durationDesc').hasError(validation.type) && (form1.get('durationDesc').dirty || form1.get('durationDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="checkInDesc"><strong>CheckIn Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="checkInDesc" id="checkInDesc" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="checkInDesc"
              id="checkInDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            <!--<label for="checkInDesc">CheckIn Description</label>-->
            @for (validation of validationMessages.checkInDesc; track validation) {
              <span>
                @if (form1.get('checkInDesc').hasError(validation.type) && (form1.get('checkInDesc').dirty || form1.get('checkInDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="parkingDesc"><strong>Parking Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="parkingDesc" id="parkingDesc" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="parkingDesc"
              id="parkingDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            <!--<label for="parkingDesc">Parking Description</label>-->
            @for (validation of validationMessages.parkingDesc; track validation) {
              <span>
                @if (form1.get('parkingDesc').hasError(validation.type) && (form1.get('parkingDesc').dirty || form1.get('parkingDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="menuDesc"><strong>Menu Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="menuDesc" id="menuDesc" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="menuDesc"
              id="menuDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            <!--<label for="menuDesc">Menu Description</label>-->
            @for (validation of validationMessages.menuDesc; track validation) {
              <span>
                @if (form1.get('menuDesc').hasError(validation.type) && (form1.get('menuDesc').dirty || form1.get('menuDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="cancelPolicy"><strong>Cancel Policy :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="cancelPolicy" id="cancelPolicy" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="cancelPolicy"
              id="cancelPolicy"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            <!--<label for="cancelPolicy">Cancel Policy</label>-->
            @for (validation of validationMessages.cancelPolicy; track validation) {
              <span>
                @if (form1.get('cancelPolicy').hasError(validation.type) && (form1.get('cancelPolicy').dirty || form1.get('cancelPolicy').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <!-- <input formControlName="duration" id="duration" type="number" pInputText> -->
            <p-inputNumber formControlName="duration" inputId="minmaxfraction" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="2" [required]="true">
            </p-inputNumber>
            <label for="duration">Duration</label>
            @for (validation of validationMessages.duration; track validation) {
              <span>
                @if (form1.get('duration').hasError(validation.type) && (form1.get('duration').dirty || form1.get('duration').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        @if (!activityId && !activityProviderId) {
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown [options]="activityProviders" formControlName="activityProviderId" appendTo="body" optionLabel="name"
                optionValue="activityProviderId" (onChange)="selectProvider()" [filter]="true" filterBy="name" [showClear]="false"
                placeholder="Select Activity Provider">
              </p-dropdown>
              <label for="Select Activity Provider">Select Activity Provider</label>
              <span>
                @if (activityProviderIdRequired) {
                  <small class="p-invalid"
                    >Activity provider is required. (If activity provider is not here in dropdown, so please add activity provider first and then add activity)
                  </small>
                }
              </span>
            </span>
          </div>
        }
      </div>

      <div class="col-lg-12">
        <label for="txtHighlight"><strong>Highlight Description :</strong></label>
        <span class="p-float-label w-100 mb-3">
          <!-- <ckeditor [editor]="editor" id="txtHighlight" formControlName="highlightDesc" (ready)="onReady($event)"></ckeditor> -->
          <editor
            formControlName="highlightDesc"
            id="txtHighlight"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
          </editor>
          <!--<label for="txtHighlight">Highlight Description</label>-->
          @for (validation of validationMessages.highlightDesc; track validation) {
            <span>
              @if (form1.get('highlightDesc').hasError(validation.type) && (form1.get('highlightDesc').dirty || form1.get('highlightDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <label for="feeDesc"><strong>Fee Description :</strong></label>
        <span class="p-float-label w-100 mb-3">
          <!-- <ckeditor [editor]="editor" formControlName="feeDesc" id="feeDesc" (ready)="onReady($event)"></ckeditor> -->
          <editor
            formControlName="feeDesc"
            id="feeDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
          </editor>
          <!--<label for="feeDesc">Fee Description</label>-->
          @for (validation of validationMessages.feeDesc; track validation) {
            <span>
              @if (form1.get('feeDesc').hasError(validation.type) && (form1.get('feeDesc').dirty || form1.get('feeDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <label for="scheduleDesc"><strong>Schedule Description :</strong></label>
        <span class="p-float-label w-100 mb-3">
          <!-- <ckeditor [editor]="editor" formControlName="scheduleDesc" id="scheduleDesc" (ready)="onReady($event)"></ckeditor> -->
          <editor
            formControlName="scheduleDesc"
            id="scheduleDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
          </editor>
          <!--<label for="scheduleDesc">Schedule Description</label>-->
          @for (validation of validationMessages.scheduleDesc; track validation) {
            <span>
              @if (form1.get('scheduleDesc').hasError(validation.type) && (form1.get('scheduleDesc').dirty || form1.get('scheduleDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <label for="termsDesc"><strong>Terms Description :</strong></label>
        <span class="p-float-label w-100 mb-3">
          <!-- <ckeditor [editor]="editor" formControlName="termsDesc" id="termsDesc" (ready)="onReady($event)"></ckeditor> -->
          <editor
            formControlName="termsDesc"
            id="termsDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
          </editor>
          <!--<label for="termsDesc">Terms Description</label>-->
          @for (validation of validationMessages.termsDesc; track validation) {
            <span>
              @if (form1.get('termsDesc').hasError(validation.type) && (form1.get('termsDesc').dirty || form1.get('termsDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      @if (activityId) {
        <h5>Upload Images</h5>
      }
      @if (activityId) {
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-fileUpload name="files[]" [customUpload]="true" (uploadHandler)="myUploader($event)" multiple="multiple"
              accept=".jpg,.jpeg,.gif" maxFileSize="52428800">
              <ng-template pTemplate="content">
                @if (uploadedFiles.length) {
                  <ul>
                    @for (file of uploadedFiles; track file) {
                      <li>{{file.name}} - {{file.size}} bytes
                      </li>
                    }
                  </ul>
                }
              </ng-template>
            </p-fileUpload>
          </span>
        </div>
      }

      @if (!isPicture && activityId) {
        <h5>Edit Images</h5>
      }
      @if (!isPicture && activityId) {
        <p-table #pt [value]="pictures" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="pictureId" selectionMode="single"
          [(selection)]="image" (onRowSelect)="onRowSelect($event)" [paginator]="true" [rows]="200"
          [rowsPerPageOptions]="[200,500,1000]" showCurrentPageReport="true"
          currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
          sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
          [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
          <ng-template pTemplate="caption">
            <div  class="d-block text-end">
              <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="unSelectAllPictures()">Unselect All</button>
              <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="selectAllPictures()">Select All</button>
              @if (forDeletePictures.length > 0) {
                <span>
                  <!--Delete Checked-->
                  <button pButton pRipple class="p-button" style="background-color:red;padding: 0.643rem 0.75rem !important;"
                  (click)="deleteMultiplePictures()">Delete Checked</button>
                </span>
              }
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th [ngStyle]="{'width': '50px'}"></th>
              @for (col of columns; track col) {
                <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              }
              <th [ngStyle]="{'width': 'auto'}"></th>
            </tr>
            <tr>
              <th [ngStyle]="{'width': '50px'}"></th>
              <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
              type="text" (input)="pt.filter($event.target.value, 'pictureId', 'in')"></th>
              <th [ngStyle]="{'width': 'auto'}"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-image>
            <tr>
              <td>
                <p-image src="{{image.url}}" alt="{{image.caption}}" width="400" preview="true"></p-image>
              </td>
              <td>
                {{image.pictureId}}
              </td>
              <td>
                <!-- <a>
                <i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
                (click)="onOpenFormEdit(image)"></i>
              </a> -->
              <a (click)="onDelete(image)"><i class="pi pi-times" aria-hidden="true"
              style="color:red; font-size:110%; padding-right:20px;"></i></a>
              <p-checkbox [(ngModel)]="image.checked" [ngModelOptions]="{standalone: true}" [value]="image.checked" (click)="addIntoCheckedList(image)" [binary]="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }


  </div>
</div>
<hr>
  @if (activityId) {
    <app-activity-fee-list [activityId]="activityId"  [showFilter]="false" [showPagination]="false"></app-activity-fee-list>
  }

  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (activityId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete Activity</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text"><a href="/activities">Cancel</a></button>
            @if (!activityId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add Activity</button>
            }

            @if (activityId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Activity</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

